import React from 'react';
import {
  Button,
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import {  BackdropCircular } from 'components';
import { ccreateStripeByAffiliateApi } from 'api';


export default function Stripe() {
  const {loadingStripe} = useSelector((state) => state.stripe);
  const dispatch = useDispatch();

  const handleClickStripe = () => {
    ccreateStripeByAffiliateApi({dispatch});
  };

  return (
    <div className="flex-grow flex-column relative h-full scroll-y justify-center items-center">
      <h2 className="font-bold p-2 text-center text-deep-gray">Click the button below to create your stripe account</h2>
      <Button
        color="primary"
        variant="contained"
        onClick={handleClickStripe}
      >
        Create new STRIPE account
      </Button>
      <BackdropCircular loading={loadingStripe} />
    </div>
  );
}
